__turbopack_context__.v({
  "countryCode": "CustomDropdown-module-scss-module__QIdMrW__countryCode",
  "dropdown": "CustomDropdown-module-scss-module__QIdMrW__dropdown",
  "dropdownItem": "CustomDropdown-module-scss-module__QIdMrW__dropdownItem",
  "dropdownMenu": "CustomDropdown-module-scss-module__QIdMrW__dropdownMenu",
  "dropdownMenuWrapper": "CustomDropdown-module-scss-module__QIdMrW__dropdownMenuWrapper",
  "dropdownToggle": "CustomDropdown-module-scss-module__QIdMrW__dropdownToggle",
  "scrollArrow": "CustomDropdown-module-scss-module__QIdMrW__scrollArrow",
  "spanWidth": "CustomDropdown-module-scss-module__QIdMrW__spanWidth",
});
